import React, { createContext } from 'react';
import { SimpleStep, Step, StepName } from '../../services';

const StepUrlsContext = createContext({
  stepUrlMap: {} as Partial<Record<StepName, string>>
});

const defaultProps = {
  steps: [] as SimpleStep[] | Step[]
};

const StepUrlsContextProvider: React.FC<React.PropsWithChildren<
  typeof defaultProps
>> = ({ steps, children } = defaultProps) => {
  const stepUrlMap = steps.reduce((acc, step) => {
    const stepId = (step as Step).id ?? (step as SimpleStep).stepId;
    acc[stepId] = step.url;
    return acc;
  }, {} as Partial<Record<StepName, string>>);

  return (
    <StepUrlsContext.Provider value={{ stepUrlMap }}>
      {children}
    </StepUrlsContext.Provider>
  );
};

export default StepUrlsContext;
export { StepUrlsContextProvider };
